import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from './core/auth.service';
import { CookieStorageService } from './services/cookie.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const authService = inject(AuthService); // Inject AuthService
  const cookieStorageService = inject(CookieStorageService); // Inject CookieStorageService

  let token = '';

  if (req.url.includes('/auth')) {
    return next(req);
  }

  if (
    req.url.includes('/vendors') ||
    req.url.includes('/supplier') ||
    req.url.includes('/shared')
  ) {
    token = cookieStorageService.getItem('auth_token') ?? '';
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        // Handle 401 Unauthorized - redirect to login page
        console.error('Unauthorized access - Redirecting to login');
        authService.logout();
        router.navigate(['/auth/login']);
      }
      return throwError(() => error);
    }),
  );
};
